import { Component, Input } from '@angular/core';

import { formatLoginLockRemaining } from '../../utils/login-lock';

@Component({
  selector: 'app-login-lock-hint',
  standalone: true,
  templateUrl: './login-lock-hint.component.html',
  styleUrls: ['./login-lock-hint.component.less']
})
export class LoginLockHintComponent {
  lockText = '';

  /**
   * 更新锁定提示文案。
   *
   * @param value 后端锁定状态对应的剩余秒数
   * @returns 无返回值
   * @example remainingSeconds = 872
   */
  @Input()
  set remainingSeconds(value: number | null) {
    this.lockText = value === null ? '' : `账号锁定中，请 ${formatLoginLockRemaining(value)} 后重试`;
  }
}
